import React from 'react';

interface SliderInputProps {
  label: string;
  value: number;
  onChange: (val: number) => void;
  min: number;
  max: number;
  step?: number;
  format?: 'currency' | 'percent' | 'years' | 'number';
  tooltip?: string;
}

export const SliderInput: React.FC<SliderInputProps> = ({
  label,
  value,
  onChange,
  min,
  max,
  step = 1,
  format = 'number',
  tooltip
}) => {
  const formatDisplay = (val: number) => {
    if (format === 'currency') {
      return `$${Math.round(val).toLocaleString()}`;
    }
    if (format === 'percent') {
      return `${val.toFixed(1)}%`;
    }
    if (format === 'years') {
      return `${val} yrs`;
    }
    return val.toLocaleString();
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawVal = parseFloat(e.target.value);
    if (!isNaN(rawVal)) {
      onChange(Math.max(min, Math.min(max, rawVal)));
    }
  };

  return (
    <div className="space-y-1.5 p-2.5 rounded-xl bg-slate-900/40 border border-slate-800/60 hover:border-slate-700/60 transition-all">
      <div className="flex items-center justify-between gap-2 text-xs">
        <label className="font-medium text-slate-300 flex items-center gap-1">
          {label}
          {tooltip && (
            <span className="text-slate-500 cursor-help" title={tooltip}>ⓘ</span>
          )}
        </label>
        <div className="flex items-center gap-1 font-mono text-cyan-400 font-semibold bg-slate-950/80 px-2 py-0.5 rounded border border-slate-800">
          <span>{formatDisplay(value)}</span>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(parseFloat(e.target.value))}
          className="w-full h-1.5 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-cyan-400 focus:outline-none"
        />
        <input
          type="number"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={handleInputChange}
          className="w-20 bg-slate-950 text-slate-200 text-xs font-mono rounded px-1.5 py-0.5 border border-slate-800 focus:border-cyan-500 focus:outline-none text-right"
        />
      </div>
    </div>
  );
};
